import React, { useEffect, useState } from "react";
import request from "../../Helpers/API";
import { DashVendedorMes } from "../Dashboard/Vendedor/DashVendedorMes";
import { DashClima } from "../Dashboard/Vendedor/DashClima";
import { DashTagline } from "../Dashboard/Vendedor/DashTagline";
import { DashPresas } from "../Dashboard/Vendedor/DashPresas";
import Swal from "sweetalert2";
import { LoaderScreen } from "../components/LoaderScreen";

import {
  NivelesNayarit,
  NivelesNayaritMenos1,
  NivelesNayaritMenos2,
  NivelesSinaloa,
  NivelesSinaloaMenos1,
  NivelesSinaloaMenos2,
} from "../Dashboard/Vendedor/ConsultaPresas";
import { DashScoreCardGerente } from "../Dashboard/Vendedor/DashScorecardGerente";
import { DashScoreCardVendedor } from "../Dashboard/Vendedor/DashScorecardVendedor";
import { useSelector } from "react-redux";
import { ContainerPresasScreen } from "./Presas/ContainerPresasScreen";
import { DashPresasNuevoDiseno } from "../Dashboard/Vendedor/DashPresasNuevoDiseno";

export const DashboardInicial = () => {
  const sesion = useSelector((state) => state.sesion);
  localStorage.removeItem("DatosFiltro");
  localStorage.removeItem("dashboard_filtro");
  const [state, setState] = useState({
    informacion: {},
    vendedor1: {},
    vendedor2: {},
    vendedor3: {},
  });
  const [scorecardComponent, setScorecardComponent] = useState(null);
  const [presas] = useState({
    presassinaloa: NivelesSinaloa(sesion.presas),
    presasnayarit: NivelesNayarit(sesion.presas),
    presassinaloamenos1: NivelesSinaloaMenos1(sesion.presas),
    presasnayaritmenos1: NivelesNayaritMenos1(sesion.presas),
    presassinaloamenos2: NivelesSinaloaMenos2(sesion.presas),
    presasnayaritmenos2: NivelesNayaritMenos2(sesion.presas),
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get("DashVendedor/Listado")
      .then((result) => {
        console.log(result)
        setState({
          ...state,
          informacion: result.informacion,
          vendedor1: result.vendedor1,
          vendedor2: result.vendedor2,
          vendedor3: result.vendedor3,
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("HUMAYA DIGITAL", JSON.stringify(error), "error");
      });
  }, []);

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get("SeleccionarScorecard/usuario")
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        let component;
        switch (result[0]?.rol) {
          case "Administrador":
            component = <DashScoreCardGerente />;
            break;
          case "Usuario Regional":
            component = <DashScoreCardGerente />;
            break;
          case "Gerente":
            component = <DashScoreCardGerente />;
            break;
          case "Vendedor":
            component = <DashScoreCardVendedor />;
            break;
          default:
            component = null;
            console.error(`Rol desconocido: ${result[0]?.rol}`);
        }
        setScorecardComponent(component);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("HUMAYA DIGITAL", JSON.stringify(error), "error");
      });
  }, []);

  return (
    <div id="dash-vendedor" className="scroll-4">
      <LoaderScreen loader={loader} />
      <div className="dash-vendedor-header">
        <DashTagline titulo={state.informacion.tagline} />
      </div>

      <DashVendedorMes
        titulo={`VENDEDOR DEL MES DE ${state.informacion.mes_revisado}`}
        vendedor1={state.vendedor1}
        vendedor2={state.vendedor2}
        vendedor3={state.vendedor3}
      />

      <div className="dash-vendedor-scorecard scroll-4">
        {scorecardComponent}
      </div>
      {/* <ContainerPresasScreen /> */}
      {/* <DashPresas
        presassinaloa={presas.presassinaloa}
        presasnayarit={presas.presasnayarit}
      /> */}
      <DashPresasNuevoDiseno
        presassinaloa={presas.presassinaloa}
        presasnayarit={presas.presasnayarit}
        presassinaloamenos1={presas.presassinaloamenos1}
        presasnayaritmenos1={presas.presasnayaritmenos1}
        presassinaloamenos2={presas.presassinaloamenos2}
        presasnayaritmenos2={presas.presasnayaritmenos2}
      />
    </div>
  );
};
